// extracted by mini-css-extract-plugin
export default {"content":"mantineModal_content__mzUe6","header":"mantineModal_header__Qxkm8","title":"mantineModal_title__yejvw"};